import createInformesSectionPage from "./SectionPageFactory";

const InformesInformaticaPage = createInformesSectionPage(
  "Informática",
  "Centraliza métricas de soporte, disponibilidad y performance de tus sistemas."
);

export default InformesInformaticaPage;
